module.exports = __webpack_public_path__ + "img/bdl.1cf510ca.svg";